import Main from '../components/main'
export default Main
